module.exports = __webpack_public_path__ + "static/img/ae.9fd1fcbf.svg";